import { useTranslation } from "react-i18next";

const AboutSection = () => {
  const { t } = useTranslation();

  return (
    <section className="py-16 px-6 md:px-16 sm:px-4 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <span className="inline-block bg-textBlue text-white text-md px-6 py-2 rounded-full mb-4">
            {t("about.label")}
          </span>
          <h2 className="text-4xl md:text-3xl sm:text-2xl font-bold text-gray-800">
            {t("about.title")}
          </h2>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-1 gap-12">
          {/* Left - Description */}
          <div className="space-y-6">
            <p className="text-lg text-gray-600 leading-relaxed">
              {t("about.description")}
            </p>
            <p className="text-lg text-gray-600 leading-relaxed">
              {t("about.description2")}
            </p>
          </div>

          {/* Right - Mission & Vision */}
          <div className="space-y-6">
            <div className="bg-blueLight p-6 rounded-lg">
              <h3 className="text-2xl font-semibold text-textBlue mb-3">
                {t("about.vision")}
              </h3>
              <p className="text-gray-700">{t("about.visionText")}</p>
            </div>
            <div className="bg-backgroundTeal p-6 rounded-lg">
              <h3 className="text-2xl font-semibold text-textBlue mb-3">
                {t("about.mission")}
              </h3>
              <p className="text-gray-700">{t("about.missionText")}</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
